import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Icon from '../Icon';

const CustomTooltip = ({
  title,
  tooltipKey,
  type = 'primary',
  className = '',
  vocabulary,
  mt,
  children,
}) => {
  return (
    <div
      className={className}
      data-tooltip-id={
        type === 'secondary' ? 'my-tooltip-secondary' : 'my-tooltip'
      }
      data-tooltip-variant="info"
      data-title={title}
      data-text={
        tooltipKey && vocabulary[tooltipKey]
          ? vocabulary[tooltipKey]
          : tooltipKey || null
      }
    >
      {children || <Icon type="info-circle" mt={mt} size={24} />}
    </div>
  );
};

CustomTooltip.propTypes = {
  vocabulary: PropTypes.object,
  title: PropTypes.string,
  tooltipKey: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'secondary']),
  className: PropTypes.string,
  mt: PropTypes.number,
  children: PropTypes.node,
};

export default connect(
  (state) => {
    const { vocabulary } = state.app;
    return { vocabulary };
  },
  (dispatch) => ({})
)(CustomTooltip);
